const React = require("react");

require("./AlterEgo.less");

const UserType = require("~/types/User.js").PropType;

const DiskButton = require("../DiskButton/DiskButton.jsx");

const AlterEgo = React.createClass({
    propTypes: {
        User: UserType.isRequired,
        OnSelected: React.PropTypes.func.isRequired
    },
    render() {
        const roleDisplay = this.GetRoleDisplay();

        return (<div className="cs-AlterEgo">
            <div className="cs-AlterEgo__button-box">
                <DiskButton className="btn btn-primary"
                            MarkClassName="glyphicon glyphicon-ok"
                            onClick={this.Selected} />
            </div>
            <div className="cs-AlterEgo__display-name">
                {this.props.User.DisplayName}
            </div>
            <div className="cs-AlterEgo__role">
                {roleDisplay}
            </div>
        </div>);
    },
    GetRoleDisplay() {
        switch (this.props.User.Roles[0]) {
            case "caudit-district":
                return (<span className="cs-AlterEgo__district">District</span>);
            case "caudit-division":
                return (<span className="cs-AlterEgo__division">Division</span>);
            case "caudit-super-user":
                return (<span className="cs-AlterEgo__super-user">Super User</span>);
            case "General Manager":
                return (<span className="cs-AlterEgo__super-user">General Manager</span>);
            case "Admin":
                return (<span className="cs-AlterEgo__admin">Admin</span>);
            default:
                return (<span>UNKNOWN</span>);
        }
    },
    Selected() {
        this.props.OnSelected(this.props.User);
    }
});

module.exports = AlterEgo;


// WEBPACK FOOTER //
// ./src/components/AlterEgo/AlterEgo.jsx